const config = {
  SERVER_PROTOCOL: "https",
  SERVER_IP: "configurator-beta.awareframework.com",
  SERVER_PORT: 443,
  BETA_MODE: true,
};

export default config;
